
const numberWithCommas = (x) => {
  return x.toString().replace(/\d{1,3}(?=(\d{3})+(?!\d))/g, "$&,");
  //return x.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ","); // safari error
};

export default numberWithCommas;